import { useEffect, useState } from 'react';
import { readStoredValue, writeStoredValue } from '@texas/utils/storage';

function useLocalStorage<T>(
  key: string | undefined,
  defaultValue: T,
  overrideInitialValue?: T,
  validate?: (value: unknown) => boolean,
) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    if (overrideInitialValue) {
      return overrideInitialValue;
    }

    return readStoredValue(key, defaultValue, validate);
  });

  useEffect(() => {
    writeStoredValue(key, storedValue);
  }, [key, storedValue]);

  return [storedValue, setStoredValue] as const;
}

export { useLocalStorage };
